/** Who may open the Set Meeting popup.
 *
 *  Doctors do not schedule; everyone else does. This lived as a literal string comparison
 *  at each of the six entry points, and the copies had already drifted - Tasks and Internal
 *  Tasks also excluded case managers, so the same person could schedule from the patients
 *  table but not from the tasks table. One predicate so they cannot drift again.
 *
 *  Note this only governs reaching the popup. Which therapist may be chosen once it is open
 *  is a separate rule, applied inside NewMeetingModal: only a secretariat picks freely.
 */
export const canScheduleMeeting = (userType?: string): boolean => userType !== 'doctor';
